import { _ as r } from "../internals/export.js";
import { n as a } from "../internals/number-parse-float.js";
r({
  target: "Number",
  stat: !0,
  forced: Number.parseFloat != a
}, {
  parseFloat: a
});